export const creditOperations = {
    REFILL: 'Refill',
    SPEND: 'Spend',
    REFUND: 'Refund',
};
